import * as helpers from "./helpers";
import * as globalVariables from "./globalVariables";
import translate from "./translate";
import Promotions from "./Promotions";
import FinnPromotions from "./FinnPromotions";
import Templater from "./Templater";
import FinnTemplater from "./FinnTemplater";

export default (options) => {
  let isKeyboardNavigationOn = false;
  let closeMobileNavInterval;

  const {
    statistic,
    parentSender,
    parentReceiver,
    mainSliderContainer,
    carousel,
    widgetVersion = "iFrame",
  } = options;

  if (!mainSliderContainer) throw new Error("slider container not found");
  if (!statistic) throw new Error("statistic have to be defined");
  if (!parentSender) throw new Error("parentSender have to be defined");
  if (!parentReceiver) throw new Error("parentReceiver have to be defined");
  if (!carousel) throw new Error("carousel have to be defined");

  let globalIDAnimationFrame;
  let updateLayoutTimeout;
  let isIFrameHeightSet =
    widgetVersion === "iFrame" || globalVariables.widgetHeight();
  let widgetDocumentLoaded = false;

  if (!isIFrameHeightSet) {
    document.documentElement.classList.add("autoHeight");
  }

  parentReceiver.subscribe((event) => {
    if (
      event.data.from === "dealsParentWindow" &&
      event.data.hasOwnProperty("isIFrameHeightSet")
    ) {
      isIFrameHeightSet = event.data.isIFrameHeightSet;

      if (event.data.isIFrameHeightSet) {
        document.documentElement.classList.remove("autoHeight");
      } else {
        document.documentElement.classList.add("autoHeight");
      }
    }
  });

  parentReceiver.subscribe((event) => {
    if (event.data.from === "dealsParentWindow" && event.data.originUrl) {
      statistic.parentOriginUrl = event.data.originUrl;
      statistic.parentPlatformType =
        event.data.originWindowWidth <= 720 ? "web_mobile" : "web";
      parentSender.parentOrigin = event.origin;
    }
  });

  /* Subscribe to visibility as early as possible */
  let isInViewport = false;
  let widgetViewSent = false;
  let sliderInitialized = false;
  let firstPromotionsIds = [];

  let visibilityFallbackTimer = null;

  parentReceiver.subscribe((event) => {
    if (
      event.data.from === "dealsParentWindow" &&
      typeof event.data.inViewport !== "undefined"
    ) {
      isInViewport = !!event.data.inViewport;

      if (visibilityFallbackTimer !== null) {
        clearTimeout(visibilityFallbackTimer);
        visibilityFallbackTimer = null;
      }
    }
  });

  const defaultItemsPerPage =
    parseInt(mainSliderContainer.getAttribute("data-items-per-page"), 10) || 3;

  let itemsPerPage = defaultItemsPerPage;

  const isFinn = mainSliderContainer.classList.contains("finn");
  const TemplaterClass = isFinn ? FinnTemplater : Templater;
  const PromotionsClass = isFinn ? FinnPromotions : Promotions;

  if (!helpers.supports("transform")) {
    helpers.showMessage({
      message: translate("error_outdated_browser"),
      type: "error",
    });

    throw new Error(translate("error_outdated_browser"));
  }

  const promotions = new PromotionsClass({
    fetcher: helpers.fetcher,
    perItems: itemsPerPage,
    preloadItems: itemsPerPage * 2,
  });

  const templater = new TemplaterClass({
    mainColor: globalVariables.mainColor(),
    landingPageUrl: globalVariables.newspaperLandingPageUrl(),
    newspaperName: globalVariables.newspaperName(),
    hexToRgba: helpers.hexToRgbA,
    contactsEnabled: globalVariables.widgetContactsEnabled(),
  });

  const generatePromotionsNodes = (data) => {
    const tiles = data.promotions.map((item) => templater.tile(item));

    if (isFinn && itemsPerPage === 3 && tiles.length === 3) {
      const realTiles = tiles.filter((t) => !t.classList.contains("empty"));
      if (realTiles.length === 1) {
        const empties = tiles.filter((t) => t.classList.contains("empty"));
        empties[0].dataset.span = "2";
        tiles.splice(tiles.indexOf(empties[1]), 1);
      }
    }

    return tiles;
  };

  const generateErrorMessage = (error) => {
    console.error(error);
    helpers.showMessage({
      message: error.message,
      type: "error",
    });
  };

  const getFirstPromotionsIds = (data) => {
    const { promotionsIds } = data;

    if (!sliderInitialized) {
      firstPromotionsIds = promotionsIds.slice(0, itemsPerPage);
    }

    return data;
  };

  const initTilesResponsiveness = (...params) => {
    if (!widgetDocumentLoaded) {
      const waitDocument = setInterval(() => {
        if (widgetDocumentLoaded) {
          clearInterval(waitDocument);
          initTilesResponsiveness(...params);
        }
      }, 300);
    } else {
      TemplaterClass.setTilesResponsiveness(...params);
      mainSliderContainer.classList.add("initial-tiles-scaling-finished");
    }
  };

  const sendWidgetDimensions = () => {
    if (isIFrameHeightSet) return;

    parentSender.ready().then(() => {
      parentSender.send({
        widgetDimensions: {
          width: document.body.offsetWidth,
          height: document.body.offsetHeight,
        },
      });
    });
  };

  const updateLayoutBasedOnItemsPerPage = () => {
    if (window.innerWidth === 0) {
      clearTimeout(updateLayoutTimeout);
      updateLayoutTimeout = setTimeout(updateLayoutBasedOnItemsPerPage, 1000);
      return;
    } else if (window.innerWidth <= 560) {
      itemsPerPage = 1;
    } else if (
      window.innerWidth > 560 &&
      (defaultItemsPerPage == 2 ||
        (defaultItemsPerPage == 3 && window.innerWidth <= 720))
    ) {
      itemsPerPage = 2;
    } else if (window.innerWidth > 720 && defaultItemsPerPage == 3) {
      itemsPerPage = 3;
    }

    if (isFinn && itemsPerPage !== 3) {
      const container = carousel.getSlidesContainer();
      if (container) {
        container.querySelectorAll("[data-span]").forEach((el) => el.removeAttribute("data-span"));
      }
    }

    promotions.setPerItems(itemsPerPage, isFinn);
    carousel.setTotalPages(promotions.promotionsLength() / itemsPerPage);
    carousel.setPerPage(itemsPerPage);
  };

  window.addEventListener("load", () => {
    widgetDocumentLoaded = true;
  });

  window.addEventListener(
    "resize",
    (e) => {
      if (globalIDAnimationFrame) {
        window.cancelAnimationFrame(globalIDAnimationFrame);
        globalIDAnimationFrame = null;
      }

      globalIDAnimationFrame = window.requestAnimationFrame(() => {
        updateLayoutBasedOnItemsPerPage();
        sendWidgetDimensions();
        carousel.refreshSlider(true);
        carousel.setCurrentSlide(1);

        TemplaterClass.resetTilesResponsiveness(mainSliderContainer);
        TemplaterClass.setTilesResponsiveness(
          mainSliderContainer,
          isIFrameHeightSet,
        );
      });
    },
    false,
  );

  const isElOverflown = ({ clientWidth, scrollWidth }) => {
    return scrollWidth > clientWidth;
  };

  const scrollNavToActiveEl = (nav, el) => {
    nav.firstChild.scroll({
      left: el.getBoundingClientRect().left - 16,
      behavior: "smooth",
    });
  };

  const handleHeaderNavToggle = (mobileNav) => {
    const mobileNavBtn = mobileNav.getElementsByClassName(
      "js-header-nav-mobile-btn",
    )[0];
    const mobileNavContent = mobileNav.getElementsByClassName(
      "js-header-nav-mobile-content",
    )[0];

    const openMobileNav = () => {
      mobileNavBtn.setAttribute("aria-expanded", "true");
      mobileNav.classList.add("open");
      document.addEventListener("click", closeNavOnClickOutside);
      document.addEventListener("keyup", closeNavOnClickOutside);
      document.addEventListener("keyup", closeOnEsc);

      if (!isKeyboardNavigationOn) {
        closeMobileNavInterval = setInterval(() => {
          const isHover =
            mobileNav.parentElement.querySelector(":hover") === mobileNav;
          if (!isHover) closeMobileNav();
        }, 3000);
      }
    };

    const closeMobileNav = () => {
      clearInterval(closeMobileNavInterval);
      mobileNavBtn.setAttribute("aria-expanded", "false");
      mobileNav.classList.remove("open");
      document.removeEventListener("click", closeNavOnClickOutside);
      document.removeEventListener("keyup", closeNavOnClickOutside);
      document.removeEventListener("keyup", closeOnEsc);
    };

    const toggleMobileNav = (_event) => {
      if (mobileNav.classList.contains("open")) closeMobileNav();
      else openMobileNav();
    };

    const closeNavOnClickOutside = (_event) => {
      if (
        !mobileNavContent.contains(_event.target) &&
        !mobileNavBtn.contains(_event.target)
      ) {
        closeMobileNav();
      }
    };

    const closeOnEsc = (_event) => {
      if (_event.key === "Escape") closeMobileNav();
    };

    mobileNavBtn.addEventListener("click", toggleMobileNav);

    const params = window.location.search;
    if (params.length && params.includes("category_id")) {
      openMobileNav();
      const activeItem = mobileNav.getElementsByClassName(
        "js-header-nav-mobile-active",
      )[0];
      if (!activeItem) return;
      scrollNavToActiveEl(mobileNavContent, activeItem);
    }
  };

  const handleHeaderNavOverflow = (nav) => {
    const navContent = nav.firstChild;
    const mobileNav = document.getElementsByClassName(
      "js-header-nav-mobile",
    )[0];
    const showMobileNav = window.innerWidth <= 560 || isElOverflown(navContent);

    if (showMobileNav) {
      nav.style.display = "none";
      mobileNav.classList.add("visible");
      handleHeaderNavToggle(mobileNav);
    } else {
      setTimeout(function () {
        navContent.style.overflowX = "auto";
        navContent.style.justifyContent = "flex-end";
        navContent.style.maxWidth = "unset";
        nav.style.opacity = "1";
      }, 500);
    }
  };

  const handleHeaderNav = () => {
    const nav = document.getElementsByClassName("js-header-nav")[0];
    if (!nav) return;
    handleHeaderNavOverflow(nav);
  };

  const keyboardNavigationOn = (e) => {
    if (
      e.keyCode === 9 &&
      !document.body.classList.contains("keyboard-navigation-on")
    ) {
      isKeyboardNavigationOn = true;
      clearInterval(closeMobileNavInterval);

      document.body.classList.add("keyboard-navigation-on");
      document.body.classList.remove("mouse-navigation-on");
      document.body.removeEventListener("keyup", keyboardNavigationOn);
      document.body.addEventListener("mousedown", mouseNavigationOn);

      carousel.onKeyboardNavigationOn();
      window.addEventListener("blur", iframeBlur);
    }
  };

  const mouseNavigationOn = (e) => {
    if (
      e.type === "mousedown" &&
      document.body.classList.contains("keyboard-navigation-on")
    ) {
      isKeyboardNavigationOn = false;

      document.body.classList.remove("keyboard-navigation-on");
      document.body.classList.add("mouse-navigation-on");
      document.body.removeEventListener("mousedown", mouseNavigationOn);
      document.body.addEventListener("keyup", keyboardNavigationOn);

      carousel.onKeyboardNavigationOff();
      window.removeEventListener("blur", iframeBlur);
      window.removeEventListener("focus", iframeFocus);
    }
  };

  const iframeBlur = () => {
    window.addEventListener("focus", iframeFocus);
    window.removeEventListener("blur", iframeBlur);
    carousel.onKeyboardNavigationOff();
  };

  const iframeFocus = () => {
    window.addEventListener("blur", iframeBlur);
    window.removeEventListener("focus", iframeFocus);
    carousel.onKeyboardNavigationOn();
  };

  const init = () => {
    sendWidgetDimensions();

    parentSender.ready().then(() => {
      parentSender.send({ widgetReady: true });
    });

    statistic.signature = promotions.signature;

    const activateStatistics = () => {
      if (!widgetViewSent) {
        statistic.sendWidgetView();
        widgetViewSent = true;
      }

      if (sliderInitialized && firstPromotionsIds.length) {
        statistic.addToView(firstPromotionsIds, false);
        firstPromotionsIds = [];
      }
    };

    // Fallback for JS-injected version: no parent page sends inViewport messages,
    // so assume visible after 1s and activate statistics manually.
    if (visibilityFallbackTimer === null && !isInViewport) {
      visibilityFallbackTimer = setTimeout(() => {
        isInViewport = true;
        activateStatistics();
        carousel.initAutoRotate();
        if (widgetVersion !== "iFrame") {
          statistic.startSendStatisticInterval();
        }
      }, 1000);
    }

    /* In case there are no promotions */
    if (promotions.promotionsLength() === 0) {
      const noItemsBlockNode = templater.noItemsBlock();
      if (mainSliderContainer.children.length) {
        mainSliderContainer.insertBefore(
          noItemsBlockNode,
          mainSliderContainer.children[0],
        );
      } else {
        mainSliderContainer.appendChild(noItemsBlockNode);
      }

      sendWidgetDimensions();

      window.addEventListener(
        "resize",
        () => {
          if (globalIDAnimationFrame) {
            window.cancelAnimationFrame(globalIDAnimationFrame);
            globalIDAnimationFrame = null;
          }

          globalIDAnimationFrame = window.requestAnimationFrame(() => {
            sendWidgetDimensions();
          });
        },
        false,
      );

      parentReceiver.subscribe((event) => {
        if (
          event.data.from === "dealsParentWindow" &&
          event.data.inViewport &&
          !widgetViewSent
        ) {
          statistic.sendWidgetView();
          widgetViewSent = true;
        }
      });

      return false;
    }

    /* In case there are promotions */
    const slidesContainer = carousel.getSlidesContainer();

    const loadingBlockNode = document.createElement("div");
    loadingBlockNode.classList.add(
      "main-tiles-unit-wrapper",
      "js-loading-block",
    );
    loadingBlockNode.style.width = "100%";
    loadingBlockNode.innerHTML = TemplaterClass.loadingBlock();

    updateLayoutBasedOnItemsPerPage();

    const getPromotions = ({ withPreload } = { withPreload: false }) => {
      const loadingBlockNodeClone = loadingBlockNode.cloneNode(true);
      slidesContainer.appendChild(loadingBlockNodeClone);

      return promotions
        .getItems({ withPreload })
        .then((data) => {
          loadingBlockNodeClone.parentNode.removeChild(loadingBlockNodeClone);
          return data;
        })
        .then(getFirstPromotionsIds)
        .then(generatePromotionsNodes)
        .then((tilesNodes) => carousel.addSlides(tilesNodes));
    };

    getPromotions({ withPreload: true });

    /* On slides are added to carousel */
    mainSliderContainer.addEventListener(
      "add-slides.after.innocode-carousel",
      () => {
        if (!sliderInitialized) {
          sliderInitialized = true;
          TemplaterClass.uploadImages(mainSliderContainer);
          initTilesResponsiveness(mainSliderContainer, isIFrameHeightSet);
          if (isInViewport) {
            statistic.addToView(firstPromotionsIds, false);
            firstPromotionsIds = [];
          }
        } else if (isFinn) {
          const container = carousel.getSlidesContainer();
          const spanned = container.querySelectorAll("[data-span]");
          if (spanned.length) {
            spanned.forEach((el) => el.removeAttribute("data-span"));
            carousel.refreshSlides();
          }
        }

        sendWidgetDimensions();

        if (!isInViewport) carousel.deinitAutoRotate();
      },
      false,
    );

    mainSliderContainer.addEventListener(
      "click.before.next.innocode-carousel.slide",
      () => {
        getPromotions().then(() => {
          TemplaterClass.uploadImages(mainSliderContainer);
          TemplaterClass.setTilesResponsiveness(
            mainSliderContainer,
            isIFrameHeightSet,
          );
        });
      },
      false,
    );

    const addToStatistic = (event) => {
      if (!isInViewport) return;

      const data = event.detail;
      const promotionsIds = data.currentSlidesNodes.map((node) => {
        const promotionNode = node.querySelector("a[data-id]");
        if (promotionNode) {
          const promotionId = promotionNode.getAttribute("data-id");
          return parseInt(promotionId, 10);
        }
        return null;
      });

      statistic.addToView(
        promotionsIds.filter((id) => id !== null && !Number.isNaN(id)),
        promotions.isLastPromotions(promotionsIds),
      );
    };

    mainSliderContainer.addEventListener(
      "click.after.next.innocode-carousel.slide",
      addToStatistic,
      false,
    );
    mainSliderContainer.addEventListener(
      "click.after.prev.innocode-carousel.slide",
      addToStatistic,
      false,
    );

    mainSliderContainer.addEventListener(
      "click",
      (event) => {
        const node = helpers.getParentByClassName(event.target, "tile");
        const itemId = node && node.getAttribute("data-id");
        if (itemId) {
          statistic.sendClick([itemId]).catch(generateErrorMessage);
        }
      },
      false,
    );

    // Restored from original: start/stop interval and autorotate on viewport enter/exit.
    // Also handles widget_view for iFrame version and re-entry after scrolling away.
    parentReceiver.subscribe((event) => {
      if (
        event.data.from === "dealsParentWindow" &&
        typeof event.data.inViewport !== "undefined"
      ) {
        if (event.data.inViewport) {
          activateStatistics();
          carousel.initAutoRotate();
          if (widgetVersion !== "iFrame") {
            statistic.startSendStatisticInterval();
          }
        } else {
          if (widgetVersion !== "iFrame") {
            statistic.endSendStatisticInterval();
          }
          carousel.deinitAutoRotate();
        }
      }
    });

    return Promise.resolve(true);
  };

  window.addEventListener("DOMContentLoaded", () => {
    handleHeaderNav();
    document.body.addEventListener("keyup", keyboardNavigationOn);
    document.body.addEventListener("mousedown", mouseNavigationOn);
  });

  return promotions.ready().then(init).catch(generateErrorMessage);
};
